import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Drawer, Affix, ConfigProvider, theme } from "antd";
import Sidenav from "./Sidenav";
import Header from "./Header";
import Footer from "./Footer";

const { Header: AntHeader, Content, Sider } = Layout;

function Main({ children }) {
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem("dashboardTheme") === "dark");
  const [visible, setVisible] = useState(false);
  const [placement, setPlacement] = useState("right");
  const [sidenavColor, setSidenavColor] = useState("#5167c1");
  const [sidenavType, setSidenavType] = useState("transparent");
  const [fixed, setFixed] = useState(false);
  const openDrawer = () => setVisible(!visible);
  const handleSidenavType = (type) => setSidenavType(type);
  const handleSidenavColor = (color) => setSidenavColor(color);
  const handleFixedNavbar = (type) => setFixed(type);

  useEffect(() => {
    localStorage.setItem("dashboardTheme", darkMode ? "dark" : "light");
    document.body.classList.toggle("dashboard-dark", darkMode);
    return () => document.body.classList.remove("dashboard-dark");
  }, [darkMode]);

  let { pathname } = useLocation();
  pathname = pathname.replace("/", "");

  useEffect(() => {
    if (pathname === "rtl") {
      setPlacement("left");
    } else {
      setPlacement("right");
    }
  }, [pathname]);

  return (
    <ConfigProvider theme={{ algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm }}>
    <Layout
      className={`layout-dashboard ${darkMode ? "layout-dashboard-dark" : ""} ${
        pathname === "profile" ? "layout-profile" : ""
      } ${pathname === "rtl" ? "layout-dashboard-rtl" : ""}`}
      style={{ height: "100%", minHeight: "100vh", margin: 0, padding: 0 }}
    >
      <Drawer
        title={false}
        placement={placement === "right" ? "left" : "right"}
        closable={false}
        onClose={() => setVisible(false)}
        visible={visible}
        key={placement === "right" ? "left" : "right"}
        width={250}
        className={`drawer-sidebar ${
          pathname === "rtl" ? "drawer-sidebar-rtl" : ""
        }`}
        bodyStyle={{
          padding: 0,
          background: sidenavType,
        }}
      >
        <Sidenav color={sidenavColor} darkMode={darkMode} />
      </Drawer>

      <Sider
        breakpoint="lg"
        collapsedWidth={0}
        onBreakpoint={(broken) => {
          setVisible(broken);
        }}
        trigger={null}
        width={250}
        theme={darkMode ? "dark" : "light"}
        className={`sider-primary ant-layout-sider-primary ${
          sidenavType === "#fff" ? "active-route" : ""
        }`}
        style={{
          background: sidenavType,
          minHeight: "100vh",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 100,
          margin: 0,
          padding: 0,
          overflow: "hidden",
          display: window.innerWidth < 992 ? "none" : "block",
        }}
      >
        <Sidenav color={sidenavColor} darkMode={darkMode} />
      </Sider>

      <Layout
  style={{
    marginLeft: window.innerWidth <= 992 ? 0 : 250, // Leave room for sidebar
    minHeight: "100vh",
    marginTop: 60, // Push content below the 60px fixed header
    paddingTop: 0,
  }}
>
{/* 
       <AntHeader
  className={`${fixed ? "ant-header-fixed" : ""}`}
  style={{
    position: "fixed",
    top: 0,
    left: window.innerWidth <= 1024 ? 0 : 250, // Header starts right after sidebar
    width: window.innerWidth <= 1024 ? "100%" : `calc(100% - 250px)`, // Fill remaining width
    boxSizing: "border-box", // Important to prevent overflow causing scrollbar overlap
    zIndex: 101,
    margin: 0,
    padding: 0,
    height: "60px",
    // background: sidenavType,
     background: "purple", 
    transition: "background 0.3s ease",
  }}
> */}
<AntHeader
  className={`${fixed ? "ant-header-fixed" : ""}`}
  style={{
    position: "fixed",
    top: 0,
    left: window.innerWidth <= 992 ? 0 : 250, // Sidebar width
    // width: window.innerWidth <= 992 ? "100%" : "calc(100vw - 250px)",
    width: window.innerWidth <= 992 ? "100%" : "calc(100vw - 250px - 14px)", // reduce right side by 8px
    boxSizing: "border-box",
    zIndex: 101,
    margin: 0,
    padding: 0,
    height: "70px",
    background: "#0D2481",
    transition: "background 0.3s ease",
  }}
>






          <Header
            darkMode={darkMode}
            onThemeChange={setDarkMode}
            onPress={openDrawer}
            name={pathname}
            subName={pathname}
            handleSidenavColor={handleSidenavColor}
            handleSidenavType={handleSidenavType}
            handleFixedNavbar={handleFixedNavbar}
            sidenavType={sidenavType}
            sidenavColor={sidenavColor} // ✅ Passing it here
          />
        </AntHeader>

        <Content
          className="content-ant"
          style={{
            padding: window.innerWidth <= 768 ? "10px" : "0 24px 0 2px",
            marginTop: "20px",
            overflow: "auto",
          }}
        >
          {children}
        </Content>
        <Footer />
      </Layout>
    </Layout>
    </ConfigProvider>
  );
}

export default Main;
